// What a closed connection is said to be, on the screen.

/**
 * What somebody reads when they are disconnected or cannot get in: the
 * region's own words when it gave a reason meant to be read (a kick, a
 * refusal, a restart), or else the standard line for what happened. What
 * the browser or the network said goes to the console, never the screen:
 * "stream error: WebTransportError: Connection lost." tells nobody
 * anything they can act on.
 */
export function plainReason(reason: string, standard: string): string {
  const said = reason.trim();
  if (!said) return standard;
  if (/error|exception|stream|webtransport|websocket|timed? ?out|econn|socket|code|failed to/i.test(said)) {
    console.info(`connection closed: ${said}`);
    return standard;
  }
  return said;
}
